/* iSpice policy pages - 2026-10-06
   Tidies the page text for reading, without changing a word of it:
   - lines that are only bold text ("PERSONAL INFORMATION WE COLLECT") become headings
   - text broken with <br><br> becomes paragraphs
   - a heading that repeats the page title is hidden; ALL-CAPS headings are shown in sentence case;
     a whole sentence formatted as a heading is shown as a lead paragraph
   - leftover <style>/<meta> tags pasted into the page text are removed (one coloured every span orange)
   - plain web addresses and emails become links
   - builds the "On this page" list and highlights the part being read
   App widgets inside the text (e.g. the FAQ app) are left alone. */
(function () {
  'use strict';
  var MAX_HEADING = 80;

  function norm(t) { return String(t || '').replace(/[\s ]+/g, ' ').trim(); }
  function key(t) { return norm(t).toLowerCase().replace(/&amp;|&/g, 'and').replace(/[^a-z0-9]+/g, ''); }
  function sentence(t) {
    t = norm(t);
    if (t !== t.toUpperCase() || !/[A-Z]/.test(t)) return t;
    var s = t.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  function slug(t, used) {
    var s = norm(t).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 50) || 'part';
    var id = s, n = 2;
    while (used[id]) id = s + '-' + n++;
    used[id] = 1;
    return id;
  }
  function isWidget(el) { return el.querySelector && el.querySelector('script, iframe, form, [id^="AVADA"]'); }

  // a "line" that is only one <strong>/<b> with short text
  function boldOnly(html) {
    var d = document.createElement('div');
    d.innerHTML = html;
    var t = norm(d.textContent);
    if (!t || t.length > MAX_HEADING || /:$/.test(t)) return ''; // "…the following technologies:" leads into a list
    var b = d.querySelector('strong, b');
    if (!b || norm(b.textContent) !== t) return '';
    return t;
  }

  function splitBlock(el) {
    if (isWidget(el) || !el.querySelector('br')) return;
    if (el.querySelector('p, div, ul, ol, h1, h2, h3, h4, table, hr')) return; // only plain text blocks
    var lines = el.innerHTML.split(/<br\s*\/?>/i);
    var out = [], para = [];
    function flush() {
      var html = para.join('<br>').trim();
      if (norm(html.replace(/<[^>]+>/g, ''))) out.push('<p>' + html + '</p>');
      para = [];
    }
    lines.forEach(function (line) {
      var h = boldOnly(line);
      if (h) { flush(); out.push('<h2 data-isx-made>' + h.replace(/</g, '&lt;') + '</h2>'); return; }
      if (!norm(line.replace(/<[^>]+>/g, ''))) { flush(); return; }
      para.push(line.trim());
    });
    flush();
    if (out.length < 2) return; // nothing to split
    var frag = document.createElement('div');
    frag.innerHTML = out.join('');
    while (frag.firstChild) el.parentNode.insertBefore(frag.firstChild, el);
    el.remove();
  }

  function linkify(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!/(https?:\/\/|www\.|@[a-z0-9-]+\.[a-z]{2,})/i.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        return n.parentNode.closest('a, script, style') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    var re = /(https?:\/\/[^\s<>"')]+[^\s<>"').,;:]|[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,})/gi;
    nodes.forEach(function (node) {
      var text = node.nodeValue, last = 0, m, frag = document.createDocumentFragment();
      re.lastIndex = 0;
      while ((m = re.exec(text))) {
        frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var a = document.createElement('a');
        var v = m[0];
        if (v.indexOf('@') > -1 && v.indexOf('://') === -1) { a.href = 'mailto:' + v; }
        else { a.href = v; a.target = '_blank'; a.rel = 'noopener'; }
        a.textContent = v;
        frag.appendChild(a);
        last = m.index + v.length;
      }
      if (!last) return;
      frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function tidy(root, title) {
    Array.prototype.forEach.call(root.querySelectorAll('style, meta'), function (el) { el.remove(); });
    // h1 inside the text: the page already has one
    Array.prototype.forEach.call(root.querySelectorAll('h1'), function (h) {
      var h2 = document.createElement('h2');
      h2.innerHTML = h.innerHTML;
      Array.prototype.forEach.call(h.attributes, function (a) { h2.setAttribute(a.name, a.value); });
      h.replaceWith(h2);
    });
    // paragraphs / divs built with <br>: split into paragraphs and headings
    Array.prototype.slice.call(root.querySelectorAll('p, div')).forEach(function (el) {
      if (el.closest('[id^="AVADA"]')) return;
      try { splitBlock(el); } catch (e) { console.warn('ispice-policy split', e); }
    });
    // <p><strong>Heading</strong></p>
    Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
      var t = boldOnly(p.innerHTML);
      if (t && !p.querySelector('img')) { var h = document.createElement('h2'); h.textContent = t; p.replaceWith(h); }
    });
    // headings: hide the ones that repeat the title or are empty, sentence-case ALL CAPS
    Array.prototype.forEach.call(root.querySelectorAll('h2, h3'), function (h) {
      var t = norm(h.textContent);
      if (!t && !h.querySelector('img')) { h.remove(); return; }
      if (key(t) === key(title)) { h.classList.add('isx-pl-dup'); return; }
      if (t.length > 70) { h.classList.add('isx-pl-lead'); return; } // a whole sentence styled as a heading
      var letters = t.replace(/[^A-Za-z]/g, ''), caps = t.replace(/[^A-Z]/g, '');
      if (letters.length >= 6 && caps.length / letters.length > 0.6) h.textContent = sentence(t.toUpperCase());
    });
    // empty leftovers
    Array.prototype.forEach.call(root.querySelectorAll('p, span, div'), function (el) {
      if (!norm(el.textContent) && !el.querySelector('img, iframe, video, script, [id]') && !el.id) el.remove();
    });
    linkify(root);
  }

  function toc(article, root) {
    var box = article.querySelector('.isx-pl-toc');
    if (!box || !article.hasAttribute('data-isx-pl-toc')) return;
    var used = {}, items = [];
    Array.prototype.forEach.call(root.querySelectorAll('h2:not(.isx-pl-dup):not(.isx-pl-lead), h3:not(.isx-pl-dup):not(.isx-pl-lead)'), function (h) {
      var t = norm(h.textContent);
      if (!t || t.length > 70) return;
      if (!h.id) h.id = slug(t, used);
      items.push({ el: h, text: t, sub: h.tagName === 'H3' });
    });
    if (items.length < 3) return;
    var ol = box.querySelector('ol');
    items.forEach(function (it) {
      var li = document.createElement('li');
      if (it.sub) li.className = 'is-sub';
      var a = document.createElement('a');
      a.href = '#' + it.el.id;
      a.textContent = it.text;
      li.appendChild(a);
      ol.appendChild(li);
    });
    box.hidden = false;
    article.classList.add('has-toc');
    // phones / tablets: the list folds away behind its label
    var label = box.querySelector('p');
    label.setAttribute('role', 'button');
    label.setAttribute('tabindex', '0');
    label.setAttribute('aria-expanded', 'false');
    function toggle(open) {
      open = typeof open === 'boolean' ? open : !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      label.setAttribute('aria-expanded', String(open));
    }
    label.addEventListener('click', function () { toggle(); });
    label.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    ol.addEventListener('click', function (e) { if (e.target.closest('a')) toggle(false); });
    if (!('IntersectionObserver' in window)) return;
    var links = ol.querySelectorAll('a'), current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) current = e.target.id; });
      Array.prototype.forEach.call(links, function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + current); });
    }, { rootMargin: '-15% 0px -70% 0px' });
    items.forEach(function (it) { io.observe(it.el); });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-isx-pl]'), function (article) {
      if (article.dataset.isxDone) return;
      article.dataset.isxDone = '1';
      var root = article.querySelector('.isx-pl-body');
      var title = norm((article.querySelector('.isx-pl-title') || {}).textContent);
      try { tidy(root, title); } catch (e) { console.warn('ispice-policy tidy', e); }
      try { toc(article, root); } catch (e) { console.warn('ispice-policy toc', e); }
      article.classList.add('is-ready');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
